import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ListChecks, ExternalLink, MessageSquare } from "lucide-react";
import BackButton from "../components/BackButton";
import { api } from "../lib/api";
import { Badge } from "../components/ui/badge";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";

const TYPE_LABEL = {
  call: "Chiamata", meeting: "Riunione", email: "Email", demo: "Demo",
  follow_up: "Follow-up", note: "Nota",
  proposal_sent: "Proposta inviata", contract_signed: "Contratto firmato",
};

export default function CrmActivities() {
  const nav = useNavigate();
  const [items, setItems] = useState([]);
  const [type, setType] = useState("all");
  const [loading, setLoading] = useState(true);

  async function load() {
    setLoading(true);
    try {
      const p = { limit: 200 };
      if (type !== "all") p.type = type;
      const r = await api.crmActivities(p);
      setItems(r || []);
    } catch { toast.error("Errore caricamento"); }
    finally { setLoading(false); }
  }
  useEffect(() => { load(); }, [type]);

  return (
    <div className="space-y-4" data-testid="crm-activities-page">
      {/* Bug 21/50 · su /prime-vision/crm/activities Shell mostra già BackButton auto.
          Rimosso duplicato manuale. */}
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div className="flex items-center gap-2">
          <ListChecks size={22} className="opacity-70" />
          <h1 className="font-display text-3xl sm:text-4xl font-semibold">Attività CRM</h1>
        </div>
        <Select value={type} onValueChange={setType}>
          <SelectTrigger className="w-56" data-testid="crm-act-filter"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Tutti i tipi</SelectItem>
            {Object.entries(TYPE_LABEL).map(([v, l]) => <SelectItem key={v} value={v}>{l}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>

      <div className="pxos-card p-0 overflow-hidden">
        {loading ? (
          <div className="p-8 text-center opacity-70">Caricamento…</div>
        ) : items.length === 0 ? (
          <div className="p-8 text-center opacity-70" data-testid="crm-act-empty">Nessuna attività.</div>
        ) : (
          <ul>
            {items.map((a) => (
              <li key={a.id} className="p-4 border-b flex items-center justify-between gap-2"
                  style={{ borderColor: "var(--pxos-border)" }}>
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2 text-sm">
                    <MessageSquare size={12} className="opacity-60" />
                    <Badge variant="outline">{TYPE_LABEL[a.activity_type] || a.activity_type}</Badge>
                    {a.subject && <span className="font-medium truncate">{a.subject}</span>}
                  </div>
                  {a.description && <div className="text-xs opacity-70 mt-1 line-clamp-2">{a.description}</div>}
                  <div className="text-xs opacity-60 mt-1">
                    {new Date(a.completed_at || a.scheduled_at || a.created_at).toLocaleString("it-IT")}
                    {a.outcome && <> · Esito: <em>{a.outcome}</em></>}
                  </div>
                </div>
                <button className="text-xs text-sky-700 hover:underline flex items-center gap-1"
                        onClick={() => nav(`/prime-vision/crm/${a.lead_id}`)}>
                  Apri lead <ExternalLink size={10} />
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
